module.exports = __webpack_public_path__ + "img/passionateaboutdevelopment_notcompleted.6fd4cc72.svg";